import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export type ReviewAccountValuesModalJurisdictionData =
  | {
      type: 'over-max';
      jurisdictionName: string;
      maxAnnualAmount: number | null;
      maximumRaised: boolean;
      monthlyPaymentAmount: number;
      estimatedAnnualTotal: number;
    }
  | {
      type: 'under-min';
      jurisdictionName: string;
      minAnnualAmount: number;
      monthlyPaymentAmount: number;
      estimatedAnnualTotal: number;
    };

@Component({
  selector: 'app-variable-benefit-configuration-review-account-values-modal',
  templateUrl: './variable-benefit-configuration-review-account-values-modal.component.html',
  styleUrls: ['./variable-benefit-configuration-review-account-values-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VariableBenefitConfigurationReviewAccountValuesModalComponent {
  private ngbActiveModal = inject(NgbActiveModal);

  public jurisdictions: ReviewAccountValuesModalJurisdictionData[] = [];

  public setJurisdictions(jurisdictions: ReviewAccountValuesModalJurisdictionData[]): void {
    this.jurisdictions = jurisdictions;
  }

  public editValues(): void {
    this.ngbActiveModal.dismiss();
  }

  public continueWithSpecifiedValues(): void {
    this.ngbActiveModal.close(true);
  }
}
